<template>
    <v-row class="justify-center align-center" style="height:100vh">
        <v-col sm="3" lg="4" ></v-col>
        <v-col sm="6" lg="4" >
            <div style="border:1px solid black;margin:10px;padding:50px;border-radius:10px;background:white">
                <v-img :src="require('@/assets/LogoLogin.png')"/>
                <v-text-field v-model=user :label="$t('user')" prepend-inner-icon="mdi-account-circle"/>
                <v-text-field v-model=pass type="Password" :label="$t('password')" prepend-inner-icon="mdi-lock"/>
                <language-switcher></language-switcher>
                <v-row>
                    <v-col cols="4"></v-col>
                    <v-col cols="4">
                        <v-btn rounded block style="color:white" color="#097575" @click=login()><v-icon dense left>mdi-login</v-icon>{{$t ('login')}}</v-btn>
                    </v-col>
                    <v-col cols="4"></v-col>
                </v-row>
                <v-chip color="error" v-if='this.text!=""'>
                    {{text}}
                </v-chip>
            </div>
        </v-col>
        <v-col sm="3" lg="4" ></v-col>
        <v-spacer></v-spacer>
    </v-row>
</template>

<script>

import Api from "@/Api";
import LanguageSwitcher from './LanguageSwitcher.vue';

export default
{
    components: { LanguageSwitcher },
    data()
    {
        return {
            text: "",
            user:"",
            pass:""
        }
    },


    methods:
    {
        login()
        {
            const self = this;
            this.text = "";
            Api.login(this.user,this.pass).then(function(result)
            {
                if (result.status === 200)
                {
                    const isAdmin = result.data.isAdmin;
                    const name = result.data.name;
                    const qlikUrl = result.data.qlikUrl ? result.data.qlikUrl + "?language=" + self.$i18n.locale : "";
                    const qlikToken = result.data.qlikToken;
                    const refreshToken = result.data.refreshToken;
                    let lastLogin = result.data.lastLogin;
                    if (lastLogin != null)
                        lastLogin = lastLogin.replace("GMT, ''");
                    self.$store.state.isAdmin = isAdmin;
                    self.$store.state.name = name;
                    self.$store.state.qlikUrl = qlikUrl;
                    self.$store.state.qlikToken = qlikToken;
                    self.$store.state.lastLogin = lastLogin;
                    self.$store.state.refreshToken = refreshToken;
                    let deep = window.location.search.startsWith("?deeplink")
                    if (deep)
                    {
                        const deepLink = "https://qlik-prod.otc-cube.com/jwt"+decodeURIComponent(window.location.search.replace("?deeplink=",""))
                        self.$store.state.deepLink = deepLink;
                    }
                    const page = deep ? "/deeplink" : qlikUrl ? "/dashboards" : "/pzns"

                    if (self.$router.currentRoute.path !== page)
                        self.$router.push(page);

                    if (isAdmin)
                    {
                        Api.getRecords("customers", 1, 100, "", "customername", false).then(response =>
                        {
                            const customers = response.data.result;
                            self.$store.state.customers = customers;
                        })
                        .catch((e) =>
                        {
                            console.log(e);
                        });
                        Api.getRecords("pharmacies", 1, 100, "", "name", false).then(response =>
                        {
                            const p = response.data.result;
                            self.$store.state.pharmacies = p;
                        })
                        .catch((e) =>
                        {
                            console.log(e);
                        });
                    }

                    Api.getSettings("FOLDER").then(response =>
                    {
                        const folders = response.data.result;
                        self.$store.state.folders = folders;
                    })
                    .catch((e) =>
                    {
                        console.log(e);
                    });

                    Api.getCatalogs("COUNTRY").then(response =>
                    {
                        const countries = response.data.result;
                        self.$store.state.countries = {}
                        for (let country of countries)
                        {
                            self.$store.state.countries[country.code] = self.$t(country.value);
                        }
                    })
                    .catch((e) =>
                    {
                        console.log(e);
                    });
                }
            })
            .catch((e) =>
            {
                this.text = self.$t("login invalid")
            });
        }
    }
}
</script>

<style lang="css">
</style>